import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';
import { isInternalUser } from '@xbcb/client-utils';
import { useCurrentUser } from 'libs/hooks';
import {
  getAglCentralDomainForStage,
  getMonsDomainForStage,
} from '../../libs/userMigrationTools';

const DEPRECATED_DOMAINS = ['cbms.inlt.com'];

const ModalContent = styled.div`
  text-align: center;
`;

const CountdownText = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin: 16px 0;
`;

const DeprecationModal = (): JSX.Element | null => {
  const [countdown, setCountdown] = useState(10);
  const [showDeprecationModal, setShowDeprecationModal] = useState(false);
  const currentUser = useCurrentUser();

  // Check for deprecated domain
  useEffect(() => {
    if (DEPRECATED_DOMAINS.includes(window.location.hostname)) {
      setShowDeprecationModal(true);
    }
  }, []);

  // Countdown timer and redirect
  useEffect(() => {
    if (showDeprecationModal && countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else if (showDeprecationModal && countdown === 0) {
      const userEmail = currentUser?.email;
      const isInternal = userEmail ? isInternalUser(userEmail) : false;
      const redirectDomain = isInternal
        ? getMonsDomainForStage()
        : getAglCentralDomainForStage() + '/migrate';
      window.location.href = `https://${redirectDomain}`;
    }
    return;
  }, [showDeprecationModal, countdown, currentUser?.email]);

  return (
    <Modal
      open={showDeprecationModal}
      closable={false}
      maskClosable={false}
      footer={null}
      title="Domain Deprecation Notice"
      centered
    >
      <ModalContent>
        <p>
          <strong>Warning:</strong> You are accessing a deprecated domain (
          {window.location.hostname}).
        </p>
        <p>
          This domain will be retired soon. You will be automatically redirected
          to the correct domain in:
        </p>
        <CountdownText>{countdown} seconds</CountdownText>
        <p>Please update your bookmarks to use the new domain.</p>
      </ModalContent>
    </Modal>
  );
};

export default DeprecationModal;
